module.exports = __webpack_public_path__ + "static/media/Max_Bet@3x.894d379c.png";